/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ProgressBar from 'Components/header/components/ProgressBar';
import cn from 'classnames';
import LockIcon from '@material-ui/icons/Lock';
import RightArrowImg, {
  ReactComponent as RightArrow,
} from 'Assets/category-right-arrow.svg';
import LeftArrowImg, {
  ReactComponent as LeftArrow,
} from 'Assets/category-left-arrow.svg';
import AlterImage from 'Assets/no-image-available.png';
import { dataFetcher, endpoints, axios, baseUrl } from 'Api';
import { ProfilePage, Button } from 'Components';
import { AuthContext, AppContext } from 'Context';
// eslint-disable-next-line
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line
import "swiper/swiper-bundle.min.css"; // ✅ Import full Swiper styles
// eslint-disable-next-line
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { Pathname } from 'Routes';
import { Image } from 'semantic-ui-react';
import { Box } from '@material-ui/core';
import { CONTENT_TYPES } from 'Pages/private/profile';
import VideoAutoPlayer from './video-autoplayer';
import styles from './index.module.css';
import { TitleLabel } from './video-autoplayer/TitleLabel';

SwiperCore.use([Navigation, Pagination]);
const isTrueValue = true;
const isFalseValue = false;
const ImageGroupTitle = ({
  resumeMe,
  title,
  setResumeMe,
  marginTitle,
  resumeWatching,
  setLoading,
  clearResumeWatching,
}) => (
  <>
    {title && (
      <div className={styles.headingWrapper}>
        <h3
          className={cn({
            [styles.imageGroupTitle]: true,
            [styles.marginTitle]: !marginTitle,
          })}
        >
          {title}
        </h3>
        {resumeMe?.content?.length > 0 ? (
          <div
            onClick={() => {
              // setLoading(true);

              clearResumeWatching();
              setResumeMe(null);
            }}
            className={styles.clearAll}
          >
            Clear All
          </div>
        ) : null}
      </div>
    )}
  </>
);

const CustomRightArrow = ({ onClick, align }) => (
  <RightArrow
    fontSize="large"
    onClick={onClick}
    aria-label="Go to next slide"
    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right custom_arrow custom-next"
  // className="right-arrow"
  // style={{ marginTop: align && '5px' }}
  />
);

const CustomLeftArrow = ({ onClick }) => (
  <LeftArrow
    onClick={onClick}
    aria-label="Go to next slide"
    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left custom_arrow custom-prev"
  // className="left-arrow"
  // style={{ zIndex: '1000', cursor: 'pointer', height: '40px', marginLeft: '-100%', background: 'none' }}
  />
);
const ViewMyProjector = ({
  pagination,
  albumPagination,
  offset,
  setVideoOffset,
  fetchData,
  imageData,
  isphoto,
  resumeMe,
  setResumeMe,
  responseData,
  profileDetails,
  title,
  isGrid,
  type,
  catG,
  resumeWatching,
  setLoading,
  clearResumeWatching,
  handleCarousel,
  onShowPermissionModal,
  hideVideoTitles,
}) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 2, // optional, default to 1.
    },
  };

  const responsiveImage = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1.5,
      slidesToSlide: 2, // optional, default to 1.
    },
  };
  const navigate = useNavigate();
  const urlParams = useParams();
  const { getToken } = useContext(AuthContext);

  const { loader, setLoader, setcategoryLoader, userDetails, subscriptionDetails } = useContext(AppContext);
  const profileID = urlParams?.profileID || userDetails.myId;
  const carouselRefs = useRef({});
  const [currentSlides, setCurrentSlides] = useState({});
  const [isMoving, setMoving] = useState(false);
  const [showArrow, setArrows] = useState(false);
  const [showAutoPlayDiv, setAutoPlayDiv] = useState(undefined);
  const loadingMore = useRef({}); // Track loading state per playlist/category to prevent duplicate calls
  const [loadingStates, setLoadingStates] = useState({}); // Track loading state for UI (shimmer)
  const swiperInstances = useRef({}); // Store swiper instances to control them after data loads
  const filteredPhotos = imageData?.data?.filter(
    (element) => element?.photos && element?.photos?.length > 0
  );
  let myTimeout;
  const [dimensions, setDimensions] = useState({
    // top: '0px',
    // left: '0px',
  });
  const [videoDetails, setVideoDetails] = useState({
    videoURL: '',
    thumbNail: '',
    title: '',
    subCategory: '',
  });
  const mouseOverHandler = (
    event,
    id,
    video_file,
    thumbnails,
    title,
    subCategory,
    video_raw_file
  ) => {
    const rect = event.target.getBoundingClientRect();
    setDimensions({});
    setAutoPlayDiv(id);
    setVideoDetails({
      videoURL: video_file || video_raw_file,
      thumbNail: thumbnails,
      title,
      subCategory,
    });
  };

  const mouseLeaveHandler = () => {
    clearInterval(myTimeout);
    setAutoPlayDiv(undefined);
    setVideoDetails({
      videoURL: '',
      thumbNail: '',
      title: '',
      subCategory: '',
    });
  };

  // Check video permission
  // TODO: TEMPORARY - All access enabled. Revert to original logic when needed.
  const hasVideoPermission = () => true;
  /* ORIGINAL hasVideoPermission LOGIC - Replace above line to restore:
  const hasVideoPermission = (videoId) => {
    try {
      // If user has upgraded plan (is_locked = 0), allow all videos
      const isLocked = subscriptionDetails?.subscription?.is_locked;
      if (isLocked === '0' || isLocked === 0) {
        return true;
      }

      // Otherwise, check if video is in allowed list
      const allowedVideoIds = JSON.parse(localStorage.getItem('allowedVideoIds') || '[]');
      return allowedVideoIds.includes(String(videoId));
    } catch (error) {
      return false;
    }
  };
  */

  // Check album permission
  // TODO: TEMPORARY - All access enabled. Revert to original logic when needed.
  const hasAlbumPermission = () => true;
  /* ORIGINAL hasAlbumPermission LOGIC - Replace above line to restore:
  const hasAlbumPermission = (albumId) => {
    try {
      // If user has upgraded plan (is_locked = 0), allow all albums
      const isLocked = subscriptionDetails?.subscription?.is_locked;
      if (isLocked === '0' || isLocked === 0) {
        return true;
      }

      // Otherwise, check if album is in allowed list
      const allowedAlbumIds = JSON.parse(localStorage.getItem('allowedAlbumIds') || '[]');
      return allowedAlbumIds.includes(String(albumId));
    } catch (error) {
      return false;
    }
  };
  */

  useEffect(() => {
    const autoPlayElement = document?.getElementById('autoplay-div');
    const thumbnailLinkElement = document?.getElementById('thumbnail-link');
    autoPlayElement?.addEventListener('mouseleave', mouseLeaveHandler);
    return () => autoPlayElement?.removeEventListener('mouseleave', mouseLeaveHandler);
  });
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLoader(false);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);
  const [swiperStates, setSwiperStates] = useState({}); // e.g., { [categoryId]: { atEnd: false, atBeginning: true } }

  function beforeChange(index, type, obj, swiper) {
    const key = obj?.category_id ?? obj?.playlist_id;
    const totalVideos = obj?.videos?.length || 0;
    const hasNextPage = obj?.videoPagination?.hasNextPage === true;

    // Calculate the last visible slide index based on slidesPerView
    const slidesPerView = swiper?.params?.slidesPerView || 4;
    const lastVisibleIndex = index + slidesPerView - 1;

    // Load more when the last visible slide is within 2 items of the end
    const shouldLoadMore = lastVisibleIndex >= totalVideos - 2;

    // console.log('🔍 beforeChange debug:', {
    //   type,
    //   key,
    //   index,
    //   slidesPerView,
    //   lastVisibleIndex,
    //   totalVideos,
    //   shouldLoadMore,
    //   hasNextPage,
    //   isLoading: loadingMore.current[key],
    //   videoPagination: obj?.videoPagination,
    // });

    if (shouldLoadMore && hasNextPage && !loadingMore.current[key]) {
      loadingMore.current[key] = true; // Mark as loading to prevent duplicate calls
      setLoadingStates((prev) => ({ ...prev, [key]: true })); // Show shimmer
      console.log('✅ Triggering fetch for playlist:', key);

      setVideoOffset((prevOffsets) => {
        const currentOffset = prevOffsets[key] ?? 0;
        const newOffset = currentOffset + 10;
        console.log('📤 Fetching with offset:', newOffset);

        // Fetch more videos for this specific playlist
        // First param (pageOffset) stays 0 - we're not loading more playlists
        // Second param is the playlist_id
        // Third param is the video offset within that playlist
        fetchData(0, key, newOffset)
          .then(() => {
            console.log('✅ Fetch completed for:', key);
            // Auto-slide to show new content after a brief delay for DOM update
            setTimeout(() => {
              if (swiperInstances.current[key]) {
                swiperInstances.current[key].slideNext();
              }
            }, 100);
          })
          .catch((err) => {
            console.error('❌ Fetch error:', err);
          })
          .finally(() => {
            loadingMore.current[key] = false; // Reset loading flag when done
            setLoadingStates((prev) => ({ ...prev, [key]: false })); // Hide shimmer
          });

        return {
          ...prevOffsets,
          [key]: newOffset,
        };
      });
    }
  }
  const currentOffset = useRef(10); // start at 10 since 0 is already loaded

  function albumUpdater(index, type, obj) {
    if (index >= 3 && albumPagination?.hasNextPage === true) {
      fetchData(currentOffset.current);
      currentOffset.current += 10; // increment after fetching
    }
  }
  useEffect(() => {
    if (Array.isArray(responseData)) {
      responseData?.forEach((obj) => {
        const categoryId = obj?.category_id;
        const lastSlide = currentSlides[categoryId] || 0;

        if (carouselRefs.current[categoryId]) {
          setTimeout(() => {
            carouselRefs.current[categoryId].goToSlide(lastSlide);
          }, 200);
        }
      });
    }
  }, [responseData]);
  const [loadedImages, setLoadedImages] = useState({});
  const [albumScrollState, setAlbumScrollState] = useState({
    atBeginning: true,
    atEnd: false,
  });

  const [albumHasScroll, setAlbumHasScroll] = useState(false);
  const currentWidth = window.innerWidth;
  const slidesPerView = currentWidth >= 640 ? 4 : 3;
  const hasScrollableSlides = responseData?.content?.length > slidesPerView;
  return (
    <div>
      {loader === true ? (
        <ProgressBar fullProgress="yes" />
      ) : (
        <div
          className={cn({
            [styles.paddingTop0]: true,
            [styles.imageGroup]: true,
            [styles.paddingTopForImage]: catG,
          })}
        >
          <div
            style={{ alignItems: 'baseline' }}
            className={styles.headingWrapper}
          >
            {type === 'Resume Watching'
              && responseData?.content?.length > 0 && (
                <ImageGroupTitle
                  title="Resume watching"
                  marginTitle={catG}
                  resumeWatching={resumeWatching}
                  setLoading={setLoading}
                  clearResumeWatching={clearResumeWatching}
                />
              )}
            {type === 'Resume Watching' && responseData?.content?.length > 0 ? (
              <div
                onClick={() => {
                  alert('Are you sure you want to clear all resume watching?');
                  clearResumeWatching();
                  setResumeMe(null);
                }}
                className={styles.clearAll}
              >
                Clear All
              </div>
            ) : null}
          </div>
          {/* {searchTerm && <ImageGroupTitle title={`Search results for "${searchTerm}"`} />} */}
          <div>
            <div
              className={cn({
                [styles.imageGroupImagesContainer]: true,
                [styles.isGrid]: isGrid,
              })}
            >
              {/* resume watching */}
              {type === 'Resume Watching'
                && responseData?.content?.length > 0 && (
                  <ImageGroupTitle
                    setResumeMe={setResumeMe}
                    resumeMe={resumeMe}
                    title={resumeMe?.content_type}
                    marginTitle={catG}
                    resumeWatching={resumeWatching}
                    setLoading={setLoading}
                    clearResumeWatching={clearResumeWatching}
                  />
                )}
              <div
                onMouseEnter={() => setArrows(true)}
                onMouseLeave={() => setArrows(false)}
              >
                <Swiper
                  style={{
                    paddingLeft: '10px',
                    paddingRight: '10px',
                  }}
                  slidesPerView={slidesPerView}
                  spaceBetween={20}
                  breakpoints={{
                    0: {
                      slidesPerView: 2.2,
                      spaceBetween: 20,
                    },
                    640: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                  }}
                  navigation={hasScrollableSlides} // ✅ conditionally enabled
                  // loop
                  slidesPerGroup={2}
                  pagination={false}
                  modules={[Navigation]}
                >
                  {type === 'Resume Watching'
                    && responseData?.content?.length > 0
                    && responseData?.content?.map((obj, idx) => (
                      <SwiperSlide key={idx}>
                        <div className={styles.imageGroupImagesWrapper}>
                          <Box
                            className={cn(styles.hoverZoom, {
                              [styles.videoBlurred]: !hasVideoPermission(obj?.id)
                            })}
                            key={idx}
                          >
                            <Link
                              onMouseEnter={(event) => mouseOverHandler(
                                event,
                                idx,
                                obj?.video_file,
                                obj?.thumbnails,
                                obj?.videoTitle,
                                obj?.SubCategory,
                                obj?.video_raw_file
                              )}
                              onMouseLeave={mouseLeaveHandler}
                              className={styles.imageGroupImageLink}
                              key={idx}
                              to={`${Pathname.getVideoPath(obj?.id)}${hideVideoTitles ? '?fromGift=true' : ''}`}
                              id="thumbnail-link"
                              onClick={(e) => {
                                if (!hasVideoPermission(obj?.id)) {
                                  e.preventDefault();
                                }
                              }}
                            >
                              <VideoAutoPlayer
                                dimensions={dimensions}
                                videoDetails={resumeMe?.content[idx]}
                                thumbNail={
                                  obj?.imagekit_icon
                                  || obj?.thumbnails
                                  || AlterImage
                                }
                                videoID={showAutoPlayDiv}
                                isLocked={false /* LOCK DISABLED: !hasVideoPermission(obj?.id) */}
                                onLockedClick={onShowPermissionModal}
                              />
                              <TitleLabel
                                title={obj?.title}
                                category={obj?.SubCategory}
                                hideTitle={hideVideoTitles}
                              />
                            </Link>
                            {/* LOCK UI DISABLED - Uncomment to restore:
                            {!hasVideoPermission(obj?.id) && (
                              <div className={styles.lockIconOverlay}>
                                <LockIcon />
                              </div>
                            )}
                            */}
                          </Box>
                        </div>
                      </SwiperSlide>
                    ))}
                  <div />
                  {' '}
                  {/* Carousel bug workaround */}
                </Swiper>
              </div>
              {type === 'photo_album'
                && Array.isArray(responseData)
                && responseData.length > 0 && (
                  <ImageGroupTitle title={`${profileDetails}'s Photo Albums`} />
                )}
              {type === 'photo_album'
                && Array.isArray(responseData)
                && responseData.length > 0 && (
                  <div style={{ width: '100%' }}>
                    {responseData?.length > 6 && (
                      <div className={styles.swiperNavWrapper}>
                        <div
                          id="custom-prev-album"
                          className={cn(styles.swiperButtonPrevView, {
                            [styles.hiddenArrow]:
                              albumScrollState?.atBeginning,
                          })}
                        >
                          <img src={LeftArrowImg} alt="Prev" />
                        </div>
                        <div
                          id="custom-next-album"
                          className={cn(styles.swiperButtonNextView, {
                            [styles.hiddenArrow]:
                              albumScrollState.atEnd,
                          })}
                        >
                          <img src={RightArrowImg} alt="Next" />
                        </div>
                      </div>
                    )}
                    <Swiper
                      style={{ paddingLeft: '10px', paddingRight: '10px' }}
                      onSwiper={(swiper) => {
                        setTimeout(() => {
                          swiper.update(); // ensure layout is ready

                          // Calculate actual slidesPerView for breakpoints
                          const currentSlidesPerView = swiper.params.breakpoints
                            ? Object.entries(swiper.params.breakpoints)
                              .sort((a, b) => +a[0] - +b[0])
                              .reduce((acc, [bp, val]) => {
                                if (window.innerWidth >= bp) {
                                  // eslint-disable-next-line
                                  acc = val.slidesPerView;
                                }
                                return acc;
                              }, swiper.params.slidesPerView)
                            : swiper.params.slidesPerView;

                          // Determine scrollability
                          setAlbumHasScroll(
                            responseData.length > currentSlidesPerView
                          );

                          // Set atBeginning and atEnd
                          setAlbumScrollState({
                            atBeginning: swiper.isBeginning,
                            atEnd: swiper.isEnd,
                          });
                        }, 100);
                      }}
                      onSlideChange={(swiper) => {
                        albumUpdater(swiper.activeIndex);
                        setAlbumScrollState({
                          atBeginning: swiper.isBeginning,
                          atEnd: swiper.isEnd,
                        });
                      }}
                      slidesPerView={6}
                      spaceBetween={15}
                      breakpoints={{
                        0: {
                          slidesPerView: 3,
                          spaceBetween: 20,
                        },
                        640: {
                          slidesPerView: 6,
                          spaceBetween: 15,
                        },
                      }}
                      navigation={{
                        prevEl: '#custom-prev-album',
                        nextEl: '#custom-next-album',
                      }}
                      // loop
                      slidesPerGroup={3}
                      pagination={false}
                      modules={[Navigation]}
                    >
                      {responseData?.map((obj, index) => (
                        <SwiperSlide key={index}>
                          <div className={styles.imageGroupImagesWrapper}>
                            <Box
                              className={cn(styles.hoverZoom, {
                                [styles.videoBlurred]: !hasAlbumPermission(obj?.id)
                              })}
                            >
                              <Link
                                className={cn({
                                  [styles.imageGroupImageLink]: true,
                                  [styles.albumTransition]: true,
                                })}
                                key={index}
                                to={Pathname.getAlbumPath(obj?.id)}
                              >
                                <div className={styles.imagePlaceholder}>
                                  {!loadedImages[obj.id] && (
                                    <div
                                      className={styles.ShimmerLoaderImage}
                                    />
                                  )}
                                  <Image
                                    src={obj?.icon}
                                    className={`${styles.imageGroupImage}`}
                                    onLoad={() => setLoadedImages((prev) => ({
                                      ...prev,
                                      [obj.id]: true,
                                    }))}
                                    onError={(e) => {
                                      e.target.src = AlterImage;
                                      setLoadedImages((prev) => ({
                                        ...prev,
                                        [obj.id]: true,
                                      }));
                                    }}
                                  />
                                </div>
                                <TitleLabel title={obj?.title} hideTitle={hideVideoTitles} />
                              </Link>
                              {/* LOCK UI DISABLED - Uncomment to restore:
                              {!hasAlbumPermission(obj?.id) && (
                                <div className={styles.lockIconOverlay}>
                                  <LockIcon />
                                </div>
                              )}
                              */}
                            </Box>
                          </div>
                        </SwiperSlide>
                      ))}
                      <div />
                    </Swiper>
                  </div>
                )}
              {/* playlist section */}
              {/* {type === 'playlists' && Array.isArray(responseData) && responseData.length > 0 && (
  <ImageGroupTitle title="Playlists" />
)} */}
              <div>
                {type === 'playlists'
                  && responseData?.map((obj, i) => (
                    <div key={i}>
                      {obj?.videos?.length > 0 && (
                        <ImageGroupTitle
                          title={obj?.playlist_title}
                          marginTitle={catG}
                          resumeWatching={resumeWatching}
                          setLoading={setLoading}
                          clearResumeWatching={clearResumeWatching}
                        />
                      )}

                      {obj?.videos?.length > 0 && (
                        <div
                          onMouseEnter={() => setArrows(true)}
                          onMouseLeave={() => setArrows(false)}
                        >
                          {obj?.videoPagination?.total > 4 && (
                            <div className={styles.swiperNavWrapper}>
                              <div
                                id={`custom-prev-${obj?.playlist_id}`}
                                className={cn(styles.swiperButtonPrevView, {
                                  [styles.hiddenArrow]:
                                    swiperStates[obj?.playlist_id]?.atBeginning,
                                })}
                              >
                                <img src={LeftArrowImg} alt="Prev" />
                              </div>
                              <div
                                // className={styles.swiperButtonNext}
                                id={`custom-next-${obj?.playlist_id}`}
                                className={cn(styles.swiperButtonNextView, {
                                  [styles.hiddenArrow]:
                                    swiperStates[obj?.playlist_id]?.atEnd
                                    && !obj?.videoPagination?.hasNextPage,
                                })}
                                onClick={() => {
                                  // If at end and has more pages, trigger load
                                  if (swiperStates[obj?.playlist_id]?.atEnd && obj?.videoPagination?.hasNextPage) {
                                    console.log('🔘 Arrow clicked at end, triggering load for:', obj?.playlist_id);
                                    const key = obj?.playlist_id;
                                    if (!loadingMore.current[key]) {
                                      loadingMore.current[key] = true;
                                      setLoadingStates((prev) => ({ ...prev, [key]: true }));
                                      setVideoOffset((prevOffsets) => {
                                        const currentOffset = prevOffsets[key] ?? 0;
                                        const newOffset = currentOffset + 10;
                                        fetchData(0, key, newOffset)
                                          .then(() => {
                                            // Auto-slide to show new content
                                            setTimeout(() => {
                                              if (swiperInstances.current[key]) {
                                                swiperInstances.current[key].slideNext();
                                              }
                                            }, 100);
                                          })
                                          .finally(() => {
                                            loadingMore.current[key] = false;
                                            setLoadingStates((prev) => ({ ...prev, [key]: false }));
                                          });
                                        return { ...prevOffsets, [key]: newOffset };
                                      });
                                    }
                                  }
                                }}
                              >
                                <img src={RightArrowImg} alt="Next" />
                              </div>
                            </div>
                          )}
                          <Swiper
                            style={{
                              paddingLeft: '10px',
                              paddingRight: '10px',
                            }}
                            observer
                            observeParents
                            observeSlideChildren
                            onSwiper={(swiper) => {
                              // Store swiper instance for later control
                              swiperInstances.current[obj.playlist_id] = swiper;
                              const hasScrollableSlides = obj?.videos?.length
                                > swiper.params.slidesPerView;
                              setSwiperStates((prev) => ({
                                ...prev,
                                [obj.playlist_id]: {
                                  atBeginning: swiper.isBeginning,
                                  atEnd: swiper.isEnd,
                                  hasScrollableSlides,
                                },
                              }));
                            }}
                            slidesPerView={4}
                            spaceBetween={20}
                            breakpoints={{
                              0: {
                                slidesPerView: 2.2,
                                spaceBetween: 20,
                              },
                              640: {
                                slidesPerView: 4,
                                spaceBetween: 20,
                              },
                            }}
                            // navigation={
                            //   !!swiperStates?.[obj.category_id]
                            //     ?.hasScrollableSlides
                            // }
                            navigation={{
                              prevEl: `#custom-prev-${obj.playlist_id}`,
                              nextEl: `#custom-next-${obj.playlist_id}`,
                            }}
                            // loop
                            slidesPerGroup={2}
                            pagination={false}
                            modules={[Navigation]}
                            onReachEnd={(swiper) => {
                              // Trigger loading more when reaching the end
                              beforeChange(swiper.activeIndex, type, obj, swiper);
                            }}
                            onSlideChange={(swiper) => {
                              const hasScrollableSlides = obj?.videos?.length
                                > swiper.params.slidesPerView;
                              beforeChange(swiper.activeIndex, type, obj, swiper); // ✅ pass swiper for slidesPerView

                              setSwiperStates((prev) => ({
                                ...prev,
                                [obj.playlist_id]: {
                                  atBeginning: swiper.isBeginning,
                                  atEnd: swiper.isEnd,
                                  hasScrollableSlides,
                                },
                              }));
                            }}
                          >
                            {obj?.videos?.map(
                              (
                                {
                                  id,
                                  thumbnails,
                                  imagekit_icon,
                                  draft_thumbnails,
                                  title: videoTitle,
                                  SubCategory,
                                  video_file,
                                  video_raw_file,
                                },
                                idx
                              ) => (
                                <SwiperSlide key={idx}>
                                  <div
                                    className={styles.imageGroupImagesWrapper}
                                  >
                                    <Box
                                      className={cn(styles.hoverZoom, {
                                        [styles.videoBlurred]: !hasVideoPermission(id)
                                      })}
                                    >
                                      <Link
                                        onMouseEnter={(event) => mouseOverHandler(
                                          event,
                                          id,
                                          video_file,
                                          thumbnails,
                                          videoTitle,
                                          SubCategory,
                                          video_raw_file
                                        )}
                                        onMouseLeave={mouseLeaveHandler}
                                        className={styles.imageGroupImageLink}
                                        to={`${Pathname.getVideoPath(id)}${hideVideoTitles ? '?fromGift=true' : ''}`}
                                        state={{
                                          from: 'playlist',
                                          playlistName: obj?.playlist_title
                                        }}
                                        id="thumbnail-link"
                                        onClick={(e) => {
                                          if (!hasVideoPermission(id)) {
                                            e.preventDefault();
                                          }
                                        }}
                                      >
                                        <VideoAutoPlayer
                                          dimensions={dimensions}
                                          videoDetails={obj?.videos[idx]}
                                          thumbNail={(() => {
                                            try {
                                              return Array.isArray(thumbnails)
                                                ? thumbnails[0]
                                                : JSON.parse(thumbnails)?.[0]
                                                || AlterImage;
                                            } catch (error) {
                                              return AlterImage;
                                            }
                                          })()}
                                          videoID={showAutoPlayDiv}
                                          isLocked={false /* LOCK DISABLED: !hasVideoPermission(id) */}
                                          onLockedClick={onShowPermissionModal}
                                        />
                                        <TitleLabel
                                          title={videoTitle}
                                          category={SubCategory}
                                          hideTitle={hideVideoTitles}
                                        />
                                      </Link>
                                      {/* LOCK UI DISABLED - Uncomment to restore:
                                      {!hasVideoPermission(id) && (
                                        <div className={styles.lockIconOverlay}>
                                          <LockIcon />
                                        </div>
                                      )}
                                      */}
                                    </Box>
                                  </div>
                                </SwiperSlide>
                              )
                            )}
                            {/* Shimmer loader when fetching more videos */}
                            {loadingStates[obj?.playlist_id] && (
                              <SwiperSlide>
                                <div className={styles.imageGroupImagesWrapper}>
                                  <div className={styles.ShimmerLoader} />
                                </div>
                              </SwiperSlide>
                            )}
                            <div />
                            {' '}
                            {/* Carousel bug workaround */}
                          </Swiper>
                        </div>
                      )}
                    </div>
                  ))}
                {type === 'playlists' && pagination?.hasNextPage && (
                  <div className={styles.shimmerWrapper}>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div key={index} className={styles.ShimmerLoader} />
                    ))}
                  </div>
                )}
              </div>
              {/* {type === 'categories' && Array.isArray(responseData) && responseData.length > 0 && (
  <ImageGroupTitle title="Categories" />
)} */}
              <div>
                {type === 'categories'
                  && responseData?.map((obj, i) => (
                    <div key={i}>
                      {obj?.videos?.length > 0 && (
                        <ImageGroupTitle
                          title={obj?.category_name}
                          marginTitle={catG}
                          resumeWatching={resumeWatching}
                          setLoading={setLoading}
                          clearResumeWatching={clearResumeWatching}
                        />
                      )}

                      {obj?.videos?.length > 0 && (
                        <div
                          onMouseEnter={() => setArrows(true)}
                          onMouseLeave={() => setArrows(false)}
                        >
                          {obj?.videoPagination?.total > 4 && (
                            <div className={styles.swiperNavWrapper}>
                              <div
                                id={`custom-prev-${obj?.category_id}`}
                                className={cn(styles.swiperButtonPrevView, {
                                  [styles.hiddenArrow]:
                                    swiperStates[obj?.category_id]?.atBeginning,
                                })}
                              >
                                <img src={LeftArrowImg} alt="Prev" />
                              </div>
                              <div
                                id={`custom-next-${obj?.category_id}`}
                                className={cn(styles.swiperButtonNextView, {
                                  [styles.hiddenArrow]:
                                    swiperStates[obj?.category_id]?.atEnd,
                                })}
                              >
                                <img src={RightArrowImg} alt="Next" />
                              </div>
                            </div>
                          )}
                          <Swiper
                            style={{
                              paddingLeft: '10px',
                              paddingRight: '10px',
                            }}
                            onSwiper={(swiper) => {
                              const hasScrollableSlides = obj?.videos?.length
                                > swiper.params.slidesPerView;

                              setSwiperStates((prev) => ({
                                ...prev,
                                [obj.category_id]: {
                                  atBeginning: swiper.isBeginning,
                                  atEnd: swiper.isEnd,
                                  hasScrollableSlides, // new flag
                                },
                              }));
                            }}
                            slidesPerView={4}
                            spaceBetween={20}
                            breakpoints={{
                              0: {
                                slidesPerView: 2.1,
                                spaceBetween: 25,
                              },
                              640: {
                                slidesPerView: 4,
                                spaceBetween: 20,
                              },
                            }}
                            // navigation={
                            //   !!swiperStates?.[obj.category_id]
                            //     ?.hasScrollableSlides
                            // }
                            navigation={{
                              prevEl: `#custom-prev-${obj.category_id}`,
                              nextEl: `#custom-next-${obj.category_id}`,
                            }}
                            // loop
                            slidesPerGroup={2}
                            pagination={false}
                            modules={[Navigation]}
                            onSlideChange={(swiper) => {
                              const hasScrollableSlides = obj?.videos?.length
                                > swiper.params.slidesPerView;

                              setSwiperStates((prev) => ({
                                ...prev,
                                [obj.category_id]: {
                                  atBeginning: swiper.isBeginning,
                                  atEnd: swiper.isEnd,
                                  hasScrollableSlides,
                                },
                              }));
                            }}
                          >
                            {obj?.videos
                              ?.filter((video) => video && video.id)
                              ?.slice(0, 10)
                              ?.map((video, idx) => (
                                <SwiperSlide key={idx}>
                                  <div
                                    className={styles.imageGroupImagesWrapper}
                                  >
                                    <Box
                                      className={cn(styles.hoverZoom, {
                                        [styles.videoBlurred]: !hasVideoPermission(video?.id)
                                      })}
                                    >
                                      <Link
                                        onMouseEnter={(event) => mouseOverHandler(
                                          event,
                                          video?.id,
                                          video?.video_file,
                                          video?.thumbnails,
                                          video?.title,
                                          video?.SubCategory,
                                          video?.video_raw_file
                                        )}
                                        onMouseLeave={mouseLeaveHandler}
                                        className={styles.imageGroupImageLink}
                                        to={`${Pathname.getVideoPath(video?.id)}${hideVideoTitles ? '?fromGift=true' : ''}`}
                                        id="thumbnail-link"
                                        onClick={(e) => {
                                          if (!hasVideoPermission(video?.id)) {
                                            e.preventDefault();
                                          }
                                        }}
                                      >
                                        <VideoAutoPlayer
                                          dimensions={dimensions}
                                          videoDetails={video}
                                          thumbNail={(() => {
                                            try {
                                              if (
                                                Array.isArray(video?.thumbnails)
                                              ) {
                                                return (
                                                  video?.thumbnails[0]
                                                  || AlterImage
                                                );
                                              }
                                              const parsed = JSON.parse(
                                                video?.thumbnails
                                              );
                                              return parsed?.[0] ?? AlterImage;
                                            } catch (error) {
                                              return AlterImage;
                                            }
                                          })()}
                                          videoID={showAutoPlayDiv}
                                          isLocked={false /* LOCK DISABLED: !hasVideoPermission(video?.id) */}
                                          onLockedClick={onShowPermissionModal}
                                        />
                                        <TitleLabel
                                          title={video?.title}
                                          category={video?.SubCategory}
                                          hideTitle={hideVideoTitles}
                                        />
                                      </Link>
                                      {/* LOCK UI DISABLED - Uncomment to restore:
                                      {!hasVideoPermission(video?.id) && (
                                        <div className={styles.lockIconOverlay}>
                                          <LockIcon />
                                        </div>
                                      )}
                                      */}
                                    </Box>
                                  </div>
                                </SwiperSlide>
                              ))}
                            {(obj?.videoPagination?.total ?? obj?.videos?.filter((video) => video && video.id)?.length ?? 0) > 10 && (
                              <SwiperSlide>
                                <div
                                  className={styles.imageGroupImagesWrapper}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => navigate(`/innerpage${hideVideoTitles ? '?fromGift=true' : ''}`, {
                                    state: {
                                      category_name: obj?.category_name,
                                      category_id: obj?.category_id,
                                      icon: obj?.icon,
                                      profile_id: profileID,
                                    },
                                  })}
                                >
                                  <div
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                      borderRadius: '8px',
                                      minHeight: '200px',
                                    }}
                                  >
                                    <span style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>
                                      Show More
                                    </span>
                                  </div>
                                </div>
                              </SwiperSlide>
                            )}
                            <div />
                            {' '}
                          </Swiper>
                        </div>
                      )}
                    </div>
                  ))}
                {type === 'categories' && pagination?.hasNextPage && (
                  <div className={styles.shimmerWrapper}>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div key={index} className={styles.ShimmerLoader} />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ViewMyProjector;
